__turbopack_context__.v({
  "pbs_kids_logo": "FdMq9a_pbs_kids_logo",
  "pbs_kids_search_row": "FdMq9a_pbs_kids_search_row",
  "pbs_kids_search_row__button": "FdMq9a_pbs_kids_search_row__button",
  "pbs_kids_search_row__content": "FdMq9a_pbs_kids_search_row__content",
  "pbs_kids_search_row__description": "FdMq9a_pbs_kids_search_row__description",
  "pbs_kids_search_row__image": "FdMq9a_pbs_kids_search_row__image",
});
